module.exports = new __parcel__URL__("shop_epic_resource_box_image.ac2cab2a.png").toString();